export default {
  clapham: {
    name: "Clapham Family Practice",
    dataURL: "/kml/clapham.kml",
    latlon: [51.4629844, -0.1332908, 21]
  },
  // test: {
  //   name: "Test Practice",
  //   dataURL: "/kml/test.kml",
  //   latlon: [51.4629844, -0.1332908, 21]
  // }
};
